exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-36e3c3d0]{--tw-bg-opacity:1;background-color:rgba(66,66,66,var(--tw-bg-opacity));height:2rem;width:1px}@media (max-width:1023px){.divider[data-v-36e3c3d0]{width:5rem;height:1px}}", ""]);

// exports
